// PoweredBy.js
import React from 'react';
import { Flex } from './Container';
import { Text } from './Text';
import AionLogo from './Image';

const PoweredByAion = () => {
    return (
        <Flex centerH gap="8px">
            <Text color="#8181A0" margin="0 0 12px">
                Secured and powered by
            </Text>
            <a target="_blank" href="https://www.aionfi.com">
                <AionLogo margin="0" logoHeight="27.5px" />
            </a>
        </Flex>
    );
};

export default PoweredByAion;
